module.exports = __webpack_public_path__ + "static/media/ios_tips_03.6afd7183.png";